<template>
  <div class="banner">
    <v-row style="height: 100%;">
      <v-col cols="12" md="4"
        ><v-row align="center" justify="center" style="height: 100%;">
          <v-col class="info-section">
            <ResponsiveText />
          </v-col> </v-row
      ></v-col>

      <v-col cols="12" md="8" class="d-none d-md-block d-lg-block">
        <v-row align="center" justify="center">
          <object
            width="100%"
            :data="require('@/assets/delivery-animation.svg')"
            type="image/svg+xml"
          ></object>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ResponsiveText from "./BannerContent/ResponsiveText";

export default {
  name: "Banner",
  components: { ResponsiveText },
};
</script>

<style scoped>
body {
  font-size: 16px;
}

.banner {
  height: 98vh;
  background-position: center;
  margin-top: -1.8rem;
  background-repeat: no-repeat;
  background-size: cover;
}

@media (max-width: 960px) {
  /* mobile and below */
  .info-section {
    text-align: center;
  }
  .banner {
    background-image: url("~@/assets/delivery-back.png");
  }
}

@media (min-width: 960px) {
  /* laptop and above */
  .banner {
    background-image: url("~@/assets/sd-background-plain.png");
  }
  .banner {
    padding-left: 5rem;
  }
}
</style>
